module.exports = __webpack_public_path__ + "img/gb-whatsapp-for-pc.2e97ea19.webp";